<template>
  <b-container fluid>
    <card class="card-body-iframe">
      <b-container class="container-report">
        <div v-if="url" class="iframe-container">
          <iframe id="reportIframe" :title="name" :src="url"></iframe>
        </div>
        <div v-else-if="showError">
          <p>Not found report {{ name }}</p>
        </div>
      </b-container>
    </card>
  </b-container>
</template>

<script>
import osdFeatures from '@/store/organization/osdFeatures'

export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    uuidName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      dynamicUrl: null,
      showError: false,
    }
  },
  mounted() {
    this.fetchUrl()
  },
  watch: {
    name: {
      handler() {
        this.fetchUrl()
      },
      immediate: true,
    },
    osdFeatureList: {
      handler() {
        this.fetchUrl()
      },
      immediate: true,
    },
    jwtToken: {
      handler() {
        this.fetchUrl()
      },
      immediate:true
    },
  },
  methods: {
    fetchUrl() {
      const iframeConfig = this.getIframeConfig()
      
      if (!this.isValidConfiguration(iframeConfig)) {
        this.showErrorAfterDelay()
        return
      }
      
      this.dynamicUrl = this.buildUrl(iframeConfig)
      this.showError = false
    },
    buildUrl(config) {
      const opensearchUrl = this.$UiConfig('/ui/opensearchUrl', '')
      let url = `${opensearchUrl}${this.selectedItem.value}`
      
      url = this.addJwtToUrl(url)
      url += this.formatQueryParam(config.queryParam)
      
      return url
    },
    getIframeConfig() {
      const iframeList = this.$UiConfig('/ui/iframes', '[]')
      return iframeList.find(item => item.name === this.name)
    },
    
    isValidConfiguration(config) {
      return config && this.selectedItem && this.selectedItem.value.length === 36
    },
    
   
    addJwtToUrl(url) {
      if (!this.jwtToken) return url
      
      const hashIndex = url.indexOf('#')
      if (hashIndex === -1) {
        return `${url}?jwt=${this.jwtToken}`
      }
      
      const beforeHash = url.substring(0, hashIndex)
      const afterHash = url.substring(hashIndex)
      return `${beforeHash}?jwt=${this.jwtToken}${afterHash}`
    },
    
    formatQueryParam(queryParam) {
      // No formatting is needed
      return queryParam
    },
    
    showErrorAfterDelay() {
      setTimeout(() => {
        this.showError = true
      }, 3000)
    },
  },
  computed: {
    url() {
      return this.dynamicUrl
    },
    osdFeatureList() {
      return this.$store.state.osdFeatures.osdFeatureList
    },
    selectedItem() {
      return this.$store.getters['osdFeatures/getByName'](this.uuidName)
    },
    jwtToken() {
      return this.$store.state.osdFeatures.jwtToken
    },
  },

  beforeCreate: async function () {
    if (!this.$store.state.osdFeatures) {
      this.$store.registerModule('osdFeatures', osdFeatures)
    }
    await this.$store.dispatch('osdFeatures/getOsdFeatureList')
  },
}
</script>

<style scoped>
@import './iframe-styles.css';
</style>
